import scrollMonitor from 'scrollmonitor';
import Parallax from 'scrollmonitor-parallax';


/**
 * inViewport
 * + Parallax mode (enable/disable in admin)
 */

const sections = document.querySelectorAll(".ps-module");
let watcher = '';

sections.forEach((section) => {

  watcher = scrollMonitor.create(section, -150);
  watcher.enterViewport(() => {
    section.classList.add('in-viewport');
  });

  if (section.querySelector('.js-parallax')) {

    var parallaxRoot = Parallax.create(section);

    var parallaxChild = parallaxRoot.add(section.querySelector('.js-parallax'), {
      start: {
        y: -100,
      },
      end: {
        y: 100
      }
    });

    if (window.matchMedia("(max-width: 1023px)").matches) {
      parallaxChild = parallaxRoot.add(section.querySelector('.js-parallax'), {
        start: {
          y: -50,
        },
        end: {
          y: 50
        }
      });
    }
  }

});
